module.exports = __webpack_public_path__ + "img/kjrc-zrc.c87793b0.jpg";